import { combineReducers } from 'redux';
import produce from 'immer';

// @ts-expect-error No types yet
import undoable, { groupByActionTypes, includeAction } from 'redux-undo';
import { CHANGE_HISTORY_LIMIT } from '../constants';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { THEME_AND_SETTINGS_FETCHED, THEME_SETTINGS_BUFFER_SAVED, THEME_SETTINGS_VARIANT_FETCHED, THEME_SETTINGS_BUFFER_PUBLISHED, THEME_SETTINGS_CHANGE_UNDONE, THEME_SETTINGS_CHANGE_REDONE, THEME_SETTINGS_UPDATED, THEME_SETTINGS_CLEARED, THEME_SETTINGS_RESET, FETCH_THEME_SUCCEEDED } from '../actions/ActionTypes';
import requestStatusFactory from './factories/requestStatusFactory';
import unset from 'hs-lodash/unset';
const themeSettingsMeta = (state = {}, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_AND_SETTINGS_FETCHED:
    case FETCH_THEME_SUCCEEDED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        //@ts-expect-error we should change key in CEUI to payload and remove this
        const payload = action.payload || action.response;
        const {
          themeSettings: {
            id,
            updated
          }
        } = payload;
        return Object.assign({}, draft, {
          id,
          updated
        });
      }
    case THEME_SETTINGS_VARIANT_FETCHED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        const {
          id
        } = action.payload;
        return Object.assign({}, draft, {
          id
        });
      }
    case THEME_SETTINGS_BUFFER_SAVED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        const {
          updated
        } = action.payload;
        return Object.assign({}, draft, {
          updated
        });
      }
    default:
      return draft;
  }
});
const themeSettingsAndBreakpointStyles = (state = {
  breakpointStyles: {},
  values: {}
}, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_AND_SETTINGS_FETCHED:
    case FETCH_THEME_SUCCEEDED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) return draft;
        //@ts-expect-error we should change key in CEUI to payload and remove this
        const payload = action.payload || action.response;
        const {
          breakpointStyles,
          values
        } = payload.themeSettings;
        Object.assign(draft, {
          breakpointStyles: breakpointStyles || {},
          values
        });
        return draft;
      }
    case THEME_SETTINGS_UPDATED:
      {
        const {
          breakpoint,
          themeSettings
        } = action.payload;
        if (breakpoint) {
          draft.breakpointStyles[breakpoint].fieldStyles = themeSettings;
        } else {
          draft.values = themeSettings;
        }
        return draft;
      }
    case THEME_SETTINGS_RESET:
      {
        const {
          breakpoint,
          key: fieldKey
        } = action.payload;
        if (breakpoint) {
          unset(draft, ['breakpointStyles', breakpoint, 'fieldStyles', ...fieldKey]);
        } else {
          unset(draft, ['values', ...fieldKey]);
        }
        return draft;
      }
    case THEME_SETTINGS_CLEARED:
      {
        draft.breakpointStyles = {};
        draft.values = {};
        return draft;
      }
    case THEME_SETTINGS_BUFFER_PUBLISHED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) return draft;
        const {
          breakpointStyles,
          values
        } = action.payload;
        draft.breakpointStyles = breakpointStyles || {};
        draft.values = values;
        return draft;
      }
    default:
      return draft;
  }
});
const undoableThemeSettingsAndBreakpointStyles = undoable(themeSettingsAndBreakpointStyles, {
  limit: CHANGE_HISTORY_LIMIT,
  ignoreInitialState: true,
  redoType: THEME_SETTINGS_CHANGE_REDONE,
  undoType: THEME_SETTINGS_CHANGE_UNDONE,
  filter: includeAction([THEME_AND_SETTINGS_FETCHED, THEME_SETTINGS_UPDATED, THEME_SETTINGS_CLEARED, THEME_SETTINGS_RESET]),
  groupBy: groupByActionTypes([THEME_AND_SETTINGS_FETCHED, THEME_SETTINGS_BUFFER_PUBLISHED])
});
export default combineReducers({
  meta: themeSettingsMeta,
  values: undoableThemeSettingsAndBreakpointStyles,
  requestStatus: requestStatusFactory(THEME_AND_SETTINGS_FETCHED),
  contentRequestStatus: requestStatusFactory(FETCH_THEME_SUCCEEDED)
});